/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/teacher.scss';
import Tab from '../../component/Inc/Tab';
function TeacherContract() {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '전체', value: 0},
    {title: '교사 계약서', value: 1},
    {title: '동의서', value: 2},
    {title: '학생 입회 계약서', value: 3}
  ];
  return (
    <main className="com_container p_contract">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu2_11">계약서 목록</h2>
        </section>
        <section className="com_pg_container">
          <section className="box box-half">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} tabStyle="fit_cont" />
            </div>

            <table className="com_board_list">
              <colgroup>
                <col width="70" />
                <col width="160" />
                <col width="160" />
                <col width="auto" />
              </colgroup>
              <thead>
                <tr>
                  <th>No</th>
                  <th>등록일</th>
                  <th>비고</th>
                  <th>계약서 명</th>
                </tr>
              </thead>
              <tbody>
                <tr className="selected">
                  <td>1</td>
                  <td>2023,05,10</td>
                  <td>교사 계약서</td>
                  <td>계약서 명</td>
                </tr>
                {[2, 3, 4, 5].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>2023,05,10</td>
                      <td>교사 계약서</td>
                      <td>계약서 명</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </section>
          {/* 상세보기 */}
          <section className="box box-half contact_box">
            <div className="contact_tit">계약서 제목</div>
            <div className="contact_cont">계약서 내용</div>
						<hr className="com_divider"/>
            <div className="com_btn_wrap center bottom ">
              <button className="com_btn orange s">삭제</button>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
}
export default TeacherContract;
